<mat-dialog-content>
  <div class="mat-typrography">{{ message }}</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" [matDialogClose]="true">{{ 'utils.discard-change.ok' | translate }}</button>
  <button mat-button [matDialogClose]="false">{{ 'utils.discard-change.cancel' | translate }}</button>
</mat-dialog-actions>
